// Copyright (c) 2015, LucrumERP Pvt. Ltd. and Contributors
// MIT License. See license.txt

if (ducky.require) {
	ducky.require("file_uploader.bundle.js");
} else {
	ducky.ready(function () {
		ducky.require("file_uploader.bundle.js");
	});
}
